import React, { createContext } from 'react';
import { useFetch } from '../hooks';

export const GrantsContext = createContext(null);

export const useMyGrants = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [grants, setGrants] = React.useState([]);
  const [modules, setModules] = React.useState([]);

  const { data, refetch } = useFetch({
    initialUrl: `/user/me`,
    headers: {
      username: user?.username,
    },
    // skip: grants?.length,
  });

  const canIdo = (grant) => {
    if (Array.isArray(grant)) {
      return grant.reduce((accumulator, curr) => {
        return accumulator || grants.includes(curr);
      }, false);
    }
    return grants.includes(grant);
  };

  React.useEffect(() => {
    if (data) {
      if (data?.role?.grants) {
        const newGrants = data?.role?.grants?.map(({ id }) => id);
        if (
          grants.sort((a, b) => (a > b ? 1 : -1)).join('-') !==
          newGrants.sort((a, b) => (a > b ? 1 : -1)).join('-')
        ) {
          setGrants(newGrants);
          const _modules = data?.role?.grants?.reduce((accumulator, curr) => {
            const temp = accumulator.includes(curr.module)
              ? accumulator
              : [...accumulator, curr.module];
            return temp;
          }, []);
          setModules(_modules);
        }
      }
    }
  }, [data]);

  return { grants, modules, ready: grants && modules, reload: refetch, canIdo };
};

export const GrantContextProvider = ({ children }) => {
  const grantsData = useMyGrants();
  return <GrantsContext.Provider value={grantsData}>{children}</GrantsContext.Provider>;
};

export const useCanIdo = () => {
  const { canIdo } = React.useContext(GrantsContext);
  return canIdo;
};
